import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { reachGoal } from '../utils/metrika';
import { formatPhoneInput } from '../utils/phoneMask';
import ConsentCheckbox from './ConsentCheckbox';

const LeadModal = ({ show, onClose, goalId }) => {
  const [phone, setPhone] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState(null);

  const handleClose = () => {
    setPhone('');
    setStatus(null);
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus(null);

    try {
      const apiUrl = window.location.port === '3000' ? 'http://localhost:5000/api/contact' : '/api/contact';
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: 'Заявка (быстрая форма)', phone, email: '', message: '' }),
      });

      if (response.ok) {
        setStatus('success');
        reachGoal(goalId);
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Оставить заявку</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group controlId="lead-phone">
            <Form.Label>Ваш телефон</Form.Label>
            <Form.Control
              type="tel"
              value={phone}
              onChange={(e) => setPhone(formatPhoneInput(e.target.value))}
              required
              autoFocus
              placeholder="+7 (___) ___-__-__"
            />
          </Form.Group>
          <ConsentCheckbox />
          {status === 'success' && (
            <p className="mt-3 mb-0 text-success">Заявка отправлена! Мы свяжемся с вами в ближайшее время.</p>
          )}
          {status === 'error' && (
            <p className="mt-3 mb-0 text-danger">Произошла ошибка. Попробуйте ещё раз.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Закрыть</Button>
          <Button variant="primary" type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Отправка...' : 'Отправить'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default LeadModal;
